import { makeStyles, useMediaQuery } from "@material-ui/core";
import { get } from "lodash";
import React, { useState } from "react";
import {
	Datagrid,
	ImageField,
	List as RaList,
	TextField,
	useGetOne,
	useTranslate,
} from "react-admin";
import Masonry from "react-masonry-css";
import Pagination from "../components/lists/Pagination";
import { useDatagridStyles } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import Actions from "./Actions";
import ApprovalDialog from "./dialogs/ApprovalDialog";
import DealField from "./fields/DealField";
import Filters from "./Filters";
import ListItem from "./ListItem";
import PromoteButton from "./PromoteButton";

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: theme.spacing(1),
	},
	logo: {
		"& img": {
			height: 90,
		},
	},
	[theme.breakpoints.down("md")]: {
		root: { margin: "1em" },
	},
}));

const Datalist = ({ data, ids, ...props }) => {
	const classes = useStyles();
	const [deal, setDeal] = useState(null);
	const [cache, setCache] = useState({});
	const handleRequestApproval = (deal) => setDeal(deal);
	const handleCloseApprovalDialog = (deal, requested) =>
		!setDeal(null) && requested && !setCache({ ...cache, [deal.id]: true });

	return (
		<div className={classes.root}>
			<Masonry
				breakpointCols={{
					default: 4,
					1100: 3,
					700: 2,
					500: 1,
				}}
				className="my-masonry-grid"
				columnClassName="my-masonry-grid_column"
			>
				{ids.map((id, index) => (
					<ListItem
						key={id}
						id={id}
						data={data}
						cache={cache[id]}
						onRequestApprovalClick={handleRequestApproval}
					/>
				))}
			</Masonry>
			{deal !== null && (
				<ApprovalDialog deal={deal} onClose={handleCloseApprovalDialog} />
			)}
		</div>
	);
};

const Description = ({ record }) => (
	<div dangerouslySetInnerHTML={{ __html: record.description }} />
);

const DefaultList = (props) => {
	const classes = useStyles();
	const translate = useTranslate();
	const [deal, setDeal] = useState(null);
	const [cache, setCache] = useState({});
	const handleRequestApproval = (deal) => setDeal(deal);
	const handleCloseApprovalDialog = (deal, requested) =>
		!setDeal(null) && requested && !setCache({ ...cache, [deal.id]: true });
	const gridClasses = useDatagridStyles();
	return (
		<React.Fragment>
			<Datagrid expand={<Description />} classes={gridClasses}>
				<ImageField
					source="logo.path"
					title="name"
					className={classes.logo}
					label=""
				/>
				<TextField
					source="name"
					label={translate("resources.bookmakers.name", 1)}
					style={{ fontWeight: "bold", textTransform: "uppercase" }}
					variant="subtitle1"
					sortable={false}
				/>
				<DealField label={translate("resources.deals.name")} hideLabel={true} />
				<PromoteButton
					cache={Object.keys(cache) > 0 ? cache : undefined}
					onRequestApprovalClick={handleRequestApproval}
					{...props}
				/>
			</Datagrid>
			{deal !== null && (
				<ApprovalDialog deal={deal} onClose={handleCloseApprovalDialog} />
			)}
		</React.Fragment>
	);
};

const Title = ({ bookmakerTypeId }) => {
	const translate = useTranslate();
	const { data } = useGetOne("bookmaker-types", bookmakerTypeId);
	return `${translate("resources.bookmaker-deals.name", 1)} ${get(
		data,
		"name",
		""
	)}`;
};

const List = (props) => {
	const {
		location: { pathname },
	} = props;
	const args = pathname.split("/");
	const id = args[args.length - 1];
	const [listType, setListType] = React.useState(
		localStorage.getItem("Deals.list_type") || "list"
	);
	const handleSelectListType = (type) => {
		setListType(type);
		localStorage.setItem("Deals.list_type", type);
	};
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	const isDataList = listType === "grid" || sm;
	const component = isDataList ? { component: "div" } : {};
	return (
		<RaList
			{...props}
			{...component}
			filters={<Filters />}
			filter={{ bookmaker_type_id: id }}
			filterDefaultValues={{ language_id: 1, status: "active" }}
			perPage={perPage(50, 25)}
			pagination={<Pagination rowsPerPageOptions={[25, 50, 100]} />}
			exporter={false}
			actions={
				!sm && <Actions onSelect={handleSelectListType} selected={listType} />
			}
			title={<Title bookmakerTypeId={id} />}
		>
			{isDataList ? <Datalist /> : <DefaultList />}
		</RaList>
	);
};
export default List;
